import type { AlphabetLetter } from '@/content/mobile';

type AlphabetSoundCardProps = {
  letter: AlphabetLetter;
  selected: boolean;
  disabled: boolean;
  onChoose: () => void;
};

/** Square green tile matching mobile `SoundCard`. */
export function AlphabetSoundCard({ letter, selected, disabled, onChoose }: AlphabetSoundCardProps) {
  const compact = letter.script.length > 6;
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      aria-label={`${letter.script}, ${letter.pronunciation}`}
      onClick={onChoose}
      className={`flex aspect-square w-full max-w-[120px] flex-col items-center justify-center rounded-lg text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-[#1E1E1E]/25 ${
        disabled
          ? 'bg-[#A5C7A0] shadow-none'
          : 'bg-[#399918] shadow-[0_2px_3.84px_rgba(0,0,0,0.25)] hover:brightness-105 active:brightness-95'
      } ${selected && !disabled ? 'shadow-[0_4px_8px_rgba(0,0,0,0.28)]' : ''}`}
    >
      <span className={`font-nunito font-bold leading-none text-white ${compact ? 'text-xl' : 'text-[40px]'}`}>
        {letter.script}
      </span>
      <span className="mt-0.5 font-nunito text-base font-normal text-white">{letter.pronunciation}</span>
    </button>
  );
}
